import React from 'react';
import { TextField } from '@mui/material';

const CustomTextField = (props) => {
  const { children, ...rest } = props;

  return (
    <TextField size="small" {...rest}>
      {children}
    </TextField>
  );
};

export default CustomTextField;
